{
  "05bd04ad273c5704": "{{count}} min late",
  "06183a1704302fd0": "Reveal SSN",
  "069d7e9d898e4d81": "Worker ID",
  "0e3b8409d3390f10": "This email is already used by another worker.",
  "12d4885ac31f81d2": "View worker profile",
  "1449d5fb47172cac": "Copy email",
  "17251b2b0d826547": "Email already assigned",
  "19766ed6ccb2f4a3": "Cancel",
  "1c30873ebfe024a3": "Open conflicting worker profile",
  "1f8184153cb31c0c": "{{miles}} mi away",
  "257c8051763d5f71": "Share credentials",
  "26d5f8d94008a3b5": "No skills listed yet",
  "2dee151577ec46d9": "Error while creating badge",
  "2ebd3eee0ba59ac5": "Open the conflicting worker profile and remove or update the email before trying again.",
  "3040c8e717b2f1c4": "View all visits",
  "34959850195f221e": "Worker skills",
  "460b3a7da007b7af": "Chat",
  "4703fd70dfd54415": "ETA",
  "4cef6ea5f6f442a1": "Updated {{ago}}",
  "4e952b41752d7990": "Live Worker ETA",
  "4efca0d10c5feb8e": "About",
  "58c687242ef4a408": "Copy Worker ID",
  "594015196a5f8bbd": "Arrived",
  "59a733f98dcb56f5": "Hide SSN",
  "5d9471f0b6fe6ebe": "Running late",
  "5efe4e47c6f5f7b1": "{{feet}} ft away",
  "5f1a2542e4e4ca5e": "Upcoming",
  "5f7905f8f05f92ab": "Live ETA is available once the professional is on their way.",
  "63dceb8800b2dd4a": "Phone",
  "66d0f523a379b2de": "Skills",
  "67d6056ee9847bae": "Close worker profile",
  "6be36ca49ee85210": "Missing",
  "712da63171e0c9de": "Unblock",
  "72bbae008b725622": "Phone number already assigned",
  "769f89083fef5866": "There was an error loading this worker's SSN. Please try again later.",
  "791eeab186dff7be": "At the facility",
  "7b4339cf860e01a6": "Qualifications",
  "7db0470e986eabd5": "Worker documents",
  "7ded289ec39c7cd4": "Download badge",
  "81421485e4fa5111": "No other shifts",
  "82b062f1b5d11be7": "View all shifts",
  "8794836f7f6f7de0": "Worker profile could not be loaded.",
  "87cd0f2528b0314b": "View All Documents",
  "8d4da37e5ca89045": "No upcoming visits.",
  "8e5c93a68c8af09d": "{{count}} min early",
  "920e413c7d411b61": "Status",
  "9334611a1a15bf72": "Conflicting phone number",
  "937d7af2b0a4d271": "name tmz",
  "9513b74847be3719": "No past visits.",
  "9671347571bf8b17": "Close booked visits",
  "969ccbd3cf6300ec": "Email",
  "9924deb0b3d22bee": "Booked Visits",
  "a2e197a272fd5b1c": "Open the conflicting worker profile and remove or update the phone number before trying again.",
  "a6b48d9a9a3aabd2": "On time",
  "a9a90d2fb18f2c5c": "Shift starts",
  "aa32d0536bab7e63": "No visits yet",
  "adb9935aefa97d3e": "Assigned to another worker",
  "b4e929d8bcfe0418": "Documents",
  "b522e0c2b9b83ef7": "No booked shifts yet.",
  "b7bdf7a2d6e73e58": "Distance",
  "c17c7df1213d835a": "This phone number is already used by another worker.",
  "c363496546214eb6": "Select the role for the professional to create the badge",
  "c8ae57613e6c105c": "Hide all shifts",
  "c8df66c5fe3f97d0": "Close dialog",
  "ca1530e8d7017547": "Past",
  "d5d6b83a02cc8d54": "Copy phone number",
  "d696a35bdd1883da": "Profile",
  "d7d98b9629d60ef6": "No eligible role found for creating a badge.",
  "e5ca7c2158feb265": "Conflicting email",
  "e6284f231417b888": "Failed to load documents.",
  "f16c49174aa5a90e": "No documents to display",
  "f3314dc78a3e0b64": "Booked Shifts"
}
